'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _autofillOnFocus = require('../enhancers/autofillOnFocus');

var _autofillOnFocus2 = _interopRequireDefault(_autofillOnFocus);

var _validateValue = require('../enhancers/validateValue');

var _validateValue2 = _interopRequireDefault(_validateValue);

var _sortValue = require('../enhancers/sortValue');

var _sortValue2 = _interopRequireDefault(_sortValue);

var _processOptions = require('../enhancers/processOptions');

var _processOptions2 = _interopRequireDefault(_processOptions);

var _autoFocusWhenLoaded = require('../enhancers/autoFocusWhenLoaded');

var _autoFocusWhenLoaded2 = _interopRequireDefault(_autoFocusWhenLoaded);

var _adaptReactSelect = require('./adaptReactSelect');

var _adaptReactSelect2 = _interopRequireDefault(_adaptReactSelect);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _propTypes2.default.func,
    object = _propTypes2.default.object,
    bool = _propTypes2.default.bool,
    any = _propTypes2.default.any,
    array = _propTypes2.default.array;

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  value: any,
  onChange: func.isRequired,
  options: array,
  schema: object,
  block: object,
  formatter: func,
  multi: bool,
  filterOptions: func
}), (0, _flattenDefaultProp2.default)('block'), (0, _flattenDefaultProp2.default)('schema'), _autofillOnFocus2.default, _validateValue2.default, _sortValue2.default, _processOptions2.default, _adaptReactSelect2.default, _autoFocusWhenLoaded2.default, (0, _exposeProps2.default)(['name', 'value', 'disabled', 'onChange', 'options', 'onFocus', 'onBlur', 'multi', 'onInputChange', 'isInvalid', 'inputRef']));

var Select = enhancer(_Select2.default);
Select.displayName = 'Select';

exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Select/index.js
// module id = 1629
// module chunks = 0